import { TextField } from "@mui/material";
import MDBox from "components/MDBox";
import { getAllMonths } from "utils/dateUtil";

export const MonthOption = ({selectedMonth, monthChangeHandler, id = "month"}) => {
  return (
    <MDBox>
      <TextField
        select
        label="Select Month"
        id={id}
        value={selectedMonth}
        helperText="*Required"
        onChange={monthChangeHandler}
        SelectProps={{
          native: true,
        }}
      >
        {getAllMonths().map((month) => (
          <option key={month.value} value={month.value}>
            {month.label}
          </option>
        ))}
      </TextField>
    </MDBox>
  );
};
